import React, { Fragment } from "react";
import Form from "react-bootstrap/Form";
import { FormSelect } from "react-bootstrap";

const renderTargetOption = (target) => (
  <span>
    {!target.itemStrength || target.itemStrength === "NONE" ? null : !target.itemUnitOfMeasure ? (
      <strong>({target.itemStrength})</strong>
    ) : (
      <strong>({`${target.itemStrength} ${target.itemUnitOfMeasure}`})</strong>
    )}
    &nbsp;
    {target.instructions ? target.instructions : null}
  </span>
);

const setCheckboxValue = (checkbox, checkboxValues, setFieldValue) => {
  const { value, checked, name } = checkbox;
  const nextValues = [...checkboxValues];

  if (checked) {
    nextValues.push(value);
  } else {
    nextValues.splice(nextValues.indexOf(value), 1);
  }

  setFieldValue(name, nextValues);
};

const SwitchDispositionFields = ({
  formValues,
  setFieldValue,
  resetDispositionFields,
  selectableDispositions,
  rawDetails,
  targetOptions,
  disableActions,
  isRawConfirmed,
  changeDisposition,
  elementIdPrefix = "switchdisposition",
}) => {
  const setRejectionReason = (rejectionReasonDropdown) => {
    const { value, name } = rejectionReasonDropdown;
    const {
      futureSwitchHandlers,
      rejectionReasonsToFutureSwitchHandlersMapping,
    } = rawDetails;

    setFieldValue(name, value);

    if (!value) {
      setFieldValue("futureSwitchTreatment", "");
      return;
    }

    const rejectionReasonCode = value.split("-")[0];
    const futureSwitchHandlerCode =
      rejectionReasonsToFutureSwitchHandlersMapping[rejectionReasonCode];
    let futureSwitchTreatment = "";

    for (const handler of futureSwitchHandlers) {
      if (handler.startsWith(futureSwitchHandlerCode)) {
        futureSwitchTreatment = handler;
        break;
      }
    }

    setFieldValue("futureSwitchTreatment", futureSwitchTreatment);
  };

  return (
    <>
      <Form.Group hidden={isRawConfirmed && !changeDisposition}>
        <Form.Label>Disposition</Form.Label>
        <FormSelect
          id={`${elementIdPrefix}-form-disposition`}
          onChange={(event) =>
            resetDispositionFields(event.target.value)
          }
          value={formValues.disposition}
          name="disposition"
          disabled={disableActions}
        >
          <option value="">Select Disposition</option>
          {Object.keys(selectableDispositions).map((key, index) =>
            rawDetails.isControlled ? (
              selectableDispositions[key] !==
              selectableDispositions.ACCEPTED ? (
                <option key={index} value={selectableDispositions[key]}>
                  {key}
                </option>
              ) : null
            ) : (
              <option key={index} value={selectableDispositions[key]}>
                {key}
              </option>
            )
          )}
        </FormSelect>
        <Form.Text className="text-muted">
          Please specify switch disposition
        </Form.Text>
      </Form.Group>

      <Form.Group
        hidden={formValues.disposition !== selectableDispositions.DECLINED}
      >
        <Form.Label>Rejection Reason</Form.Label>
        <FormSelect
          id={`${elementIdPrefix}-form-rejectionReason`}
          onChange={(event) => setRejectionReason(event.target)}
          value={formValues.rejectionReason}
          name="rejectionReason"
        >
          <option value="">Select Rejection Reason</option>
          {rawDetails.rejectionReasons.map((reason, index) => (
            <option value={reason} key={index}>
              {reason}
            </option>
          ))}
        </FormSelect>
        <Form.Text className="text-muted">
          Please specify a reason for rejection
        </Form.Text>
      </Form.Group>

      <Form.Group
        hidden={formValues.disposition !== selectableDispositions.DECLINED}
      >
        <Form.Label>Future Switch Treatment</Form.Label>
        <FormSelect
          id={`${elementIdPrefix}-form-futureSwitchTreatment`}
          onChange={(event) =>
            setFieldValue("futureSwitchTreatment", event.target.value)
          }
          value={formValues.futureSwitchTreatment}
          name="futureSwitchTreatment"
        >
          <option value="">Select Future Switch Handling</option>
          {rawDetails.futureSwitchHandlers.map((handler, index) => (
            <option value={handler} key={index}>
              {handler}
            </option>
          ))}
        </FormSelect>
        <Form.Text className="text-muted">
          Please specify future treatment for this switch
        </Form.Text>
      </Form.Group>

      <Form.Group
        hidden={formValues.disposition !== selectableDispositions.ACCEPTED}
      >
        <Form.Label>Target Option</Form.Label>
        {targetOptions.map((option, optionIndex) => (
          <div key={optionIndex}>
            <strong>
              {option.faxDisplayName || option.medName}
              &nbsp;({option.medForm})
            </strong>
            {option.instructions ? (
              <div>
                <Fragment>
                  <strong>Form Level Instructions: </strong>
                  <span>{option.instructions}</span>
                </Fragment>
              </div>
            ) : null}
            {option.dynamicSwitchItems
              .filter((item) => item.isActive && !item.isDeleted)
              .map((item, itemIndex) => (
                <div key={itemIndex}>
                  <Form.Check
                    id={`${elementIdPrefix}-form-targetOption-${itemIndex + 1}`}
                    type="checkbox"
                    value={item.dynamicSwitchItemId}
                    name="targets"
                    style={{ float: "left" }}
                    onChange={(event) =>
                      setCheckboxValue(
                        event.target,
                        formValues.targets,
                        setFieldValue
                      )
                    }
                    checked={
                      formValues.targets.indexOf(item.dynamicSwitchItemId) >=
                        0 ||
                      (option.dynamicSwitchItems.length === 1 &&
                        targetOptions.length === 1)
                    }
                    disabled={disableActions}
                  />
                  {renderTargetOption(item)}
                </div>
              ))}
            <br />
          </div>
        ))}
        <Form.Text className="text-muted">
          Please specify selected target option. Add prescriber input to notes.
        </Form.Text>
      </Form.Group>
    </>
  );
};

export default SwitchDispositionFields;
